import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import classnames from 'classnames';

const ENTER_KEY = 13;
const messages = defineMessages({
  Clear: 'Clear',
});

class TextSearch extends Component {
  state = {
    value: '',
  };
  static propTypes = {
    delay: PropTypes.number,
    value: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    delay: 1000,
    value: '',
    type: 'search',
  };

  constructor(props) {
    super(props);
    this.state.value = props.value || '';
  }

  timer = null;

  handleChange = e => {
    const { delay } = this.props;

    clearTimeout(this.timer);

    this.setState({ value: e.target.value });

    this.timer = setTimeout(this.triggerChange, delay);
  };

  handleClear = () => {
    const { onChange } = this.props;
    clearTimeout(this.timer);
    this.setState({ value: '' });
    onChange('');
    if (this.inputRef) this.inputRef.focus();
  };

  handleKeyDown = e => {
    if (e.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange();
    }
  };

  triggerChange = () => {
    const { value } = this.state;
    const { onChange } = this.props;
    onChange(value);
  };

  componentDidUpdate({ value: oldValue }) {
    const { value: newValue } = this.props;
    const { value: stateValue } = this.state;
    if (oldValue !== newValue && newValue !== stateValue) {
      clearTimeout(this.timer);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ value: newValue || '' });
    }
  }

  renderInput() {
    const { type, onChange, value: _, ...rest } = this.props;
    const { value } = this.state;

    return (
      <input
        {...rest}
        type={type}
        value={value}
        onChange={this.handleChange}
        onKeyDown={this.handleKeyDown}
        ref={ref => {
          this.inputRef = ref;
        }}
        data-1p-ignore
      />
    );
  }

  render() {
    const { intl } = this.props;
    const { value } = this.state;
    return (
      <div className={classnames({ 'input-group': value })}>
        {this.renderInput()}
        {value && (
          <span className="input-group-btn">
            <button
              type="button"
              className="btn btn-default btn-font-14"
              title={intl.formatMessage(messages.Clear)}
              onClick={this.handleClear}
            >
              <span className="fa fa-times" />
            </button>
          </span>
        )}
      </div>
    );
  }
}

export default injectIntl(TextSearch);
